import React, { useEffect, useState, memo } from 'react';
import { gql, useQuery } from '@apollo/client';
import parse, { domToReact, attributesToProps } from 'html-react-parser';         
import { Link } from 'react-router-dom';
import readConfig from '../../utils/readClientConfiguration';
import productionConfiguration from '../../config/default.json';
import { resolveLinkProps } from '../../utils/resolveLinkProps';
import './Footer.scss';
import CertifiedShop from "../Footer/CertifiedShop";

const phoneSupportNumber = readConfig(productionConfiguration, 'phoneSupportNumber');

const FETCH_FOOTER = gql`
    query getCmsBlocks($identifiers: [String]) {
        cmsHydratedBlocks(identifiers: $identifiers) {
            items {
                title
                identifier
                hydrated_content
            }
        }
    }
`;

const replaceHTMLNodesWithReact = (domNode) => {
    if (!domNode || !domNode.name) return undefined;

    const { name, attribs, children } = domNode;

    if (name === 'div' && attribs?.class === 'smdWrapperTag') {
        return <CertifiedShop/>;
    }

    if (name === 'a') {
        
        const { style, className } = attributesToProps(attribs || {});                                                                                                                                                                                                                                               

        if (attribs?.href?.startsWith('tel:')) {
           return <a href={attribs.href} style={style} className={className}>{domToReact(children, { replace: replaceHTMLNodesWithReact })}</a>;                                                                                                                                                                    
        }

        try {
            const linkProps = resolveLinkProps(attribs.href || '');
            if (linkProps.href) {
                return (
                     <a href={linkProps.href} target="_blank" rel="noopener noreferrer" style={style} className={className}>                                                                                                                                                                                          
                        {domToReact(children, { replace: replaceHTMLNodesWithReact })}
                    </a>
                );
            } else {
                const processedLink = linkProps.to.endsWith('/') ? linkProps.to.slice(0, -1) : linkProps.to;
               return <Link to={processedLink} style={style} className={className}>{domToReact(children, { replace: replaceHTMLNodesWithReact })}</Link>;                                                                                                                                                           
            }
        } catch (e) {
            console.error('Error processing link:', e);
            return undefined;
        }
    }

    return undefined;
};

const Footer = () => {
    const { data, loading, error } = useQuery(FETCH_FOOTER, {
        variables: { identifiers: ['footer_block'] },
        fetchPolicy: 'cache-first',
    });

    const scrollToTopHandler = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    if (loading) return (
        <>
            <div id="mobile-phone">
                <a role="navigation" href={`tel:${phoneSupportNumber}`}>
                    <img
                        loading="lazy"
                        alt="mobile-phone"
                        src="https://s3.emmezeta.hr/falcon/mobile_phone.svg"
                        width={50}
                        height={50}
                    />
                </a>
            </div>

            <div id="scroll-to-top">
                <button
                    onClick={scrollToTopHandler}
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                >
                    <img
                        loading="lazy"
                        alt="scroll-to-top-button"
                        id="scroll-to-top-button"
                        src="https://s3.emmezeta.hr/falcon/footer-icon-scroll-to-top.png"
                        width={50}
                        height={50}
                    />
                </button>
            </div>

            <footer className="page-footer">
                <div className="footer-container"></div>
            </footer>
        </>
    );
    if (error) return (
        <>
            <div id="mobile-phone">
                <a role="navigation" href={`tel:${phoneSupportNumber}`}>
                    <img
                        loading="lazy"
                        alt="mobile-phone"
                        src="https://s3.emmezeta.hr/falcon/mobile_phone.svg"
                        width={50}
                        height={50}
                    />
                </a>
            </div>

            <div id="scroll-to-top">
                <button
                    onClick={scrollToTopHandler}
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                >
                    <img
                        loading="lazy"
                        alt="scroll-to-top-button"
                        id="scroll-to-top-button"
                        src="https://s3.emmezeta.hr/falcon/footer-icon-scroll-to-top.png"
                        width={50}
                        height={50}
                    />
                </button>
            </div>

            <footer className="page-footer">
                <div className="footer-container"></div>
            </footer>
        </>
    );

    const block = data?.cmsHydratedBlocks?.items?.[0];
    const footerContent = block?.hydrated_content?.replace(/#html-body/g, 'body') || '';

    return (
        <>
            <div id="mobile-phone">
                <a role="navigation" href={`tel:${phoneSupportNumber}`}>
                    <img
                        loading="lazy"
                        alt="mobile-phone"
                        src="https://s3.emmezeta.hr/falcon/mobile_phone.svg"
                        width={50}
                        height={50}
                    />
                </a>
            </div>

            <div id="scroll-to-top">
                <button
                    onClick={scrollToTopHandler}
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                >
                    <img
                        loading="lazy"
                        alt="scroll-to-top-button"
                        id="scroll-to-top-button"
                        src="https://s3.emmezeta.hr/falcon/footer-icon-scroll-to-top.png"
                        width={50}
                        height={50}
                    />
                </button>
            </div>

            <footer className="page-footer">
                {footerContent && parse(`<div class="footer-container">${footerContent}</div>`, {
                    replace: replaceHTMLNodesWithReact,
                })}
            </footer>
        </>
    );
};

export default memo(Footer);
